import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TalentHappyPathDataService } from "../../shared/service/talent-happy-path-data-service";
import { TalentHappyPathAuthService } from "../../shared/service/talent-happy-path-auth.service";
import { TalentHappyPathAuthApiService } from "../../shared/service/talent-happy-path-auth-api.service";
import { QuickApplyWorkflowService } from "../quick-apply-workflow.service";

@Component({
  selector: 'app-quick-apply-otp',
  standalone: false,
  templateUrl: './quick-apply-otp.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './quick-apply-otp.component.scss'
})
export class QuickApplyOtpComponent implements OnInit {

  oneTimePasswordForm: FormGroup;
  talent: Talent;
  userHasExistingPassword: boolean = false;
  quickApplyUserCredentials: QuickApplyUserCredentials;
  passcodeAttempts: number = 0;

  constructor(
    private authServiceAPI: TalentHappyPathAuthApiService,
    private talentHappyPathDataService: TalentHappyPathDataService,
    private authService: TalentHappyPathAuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private workflowService: QuickApplyWorkflowService
  ) {}

  ngOnInit(): void {
    this.talent = this.talentHappyPathDataService.talent;
    this.userHasExistingPassword = this.talentHappyPathDataService.talent.hasExistingPassword;
    this.oneTimePasswordForm = new FormGroup({
      oneTimePassword: new FormControl(
        '',
        [
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(6),
        ]
      ),
      password: new FormControl(''),
    });
    this.workflowService.handleAuthenticatedUserOnOtp();
  }

  continue(otpForm: FormGroup): void {

      this.quickApplyUserCredentials = {
        email: this.talent.email,
        otpCode: otpForm.value.oneTimePassword,
        password: otpForm.value.password,
        existingUser: !!(this.talentHappyPathDataService.talent && this.talentHappyPathDataService.talent.personId),
        credentialType: 'passcode',
        countryId: this.talent.countryId,
        homeLocation: this.talent.homeLocation
      }

      // authenticate and login user
      this.authServiceAPI.login(this.quickApplyUserCredentials).subscribe(async (data)  => {
          if (data) {
            if (this.talentHappyPathDataService.isGeneralApplication) {
              const isNewTalent = !this.quickApplyUserCredentials.existingUser;
              if (isNewTalent) {
                await this.workflowService.navigateToState('new', {}, { relativeTo: this.activatedRoute.parent});
              } else {
                await this.workflowService.navigateToState('update', {}, { relativeTo: this.activatedRoute.parent});
              }
            }
            else if (this.talentHappyPathDataService.goToVmsSub) {
              this.router.navigate(['vms-submittal', this.talentHappyPathDataService.postingId]);
            }
            else {
              await this.workflowService.navigateToState('submit', {} , { relativeTo: this.activatedRoute.parent, skipLocationChange: true });
            }
          }
        }, error => {
        console.log(error);
          console.error("Error verifying passcode")
        this.oneTimePasswordForm.controls.oneTimePassword.setErrors({});

        if (error.data === 'Invalid Code') {
          this.oneTimePasswordForm.controls.oneTimePassword.setErrors ({ invalid: true });
        } else if (error.data === 'Code Expired') {
          this.oneTimePasswordForm.controls.oneTimePassword.setErrors ({ codeExpired: true });
        }
            this.passcodeAttempts++;
            if (this.passcodeAttempts >= 3) {
              this.oneTimePasswordForm.controls.oneTimePassword.setErrors ({ maxAttemptsReached: true });
            }
        });
  }

  getErrorMessage(): string {
    if (this.oneTimePasswordForm.controls.oneTimePassword.hasError('maxAttemptsReached')) {
      return 'talent-happy-path.quick-apply.otp-page.max-attempts';
    } else if (this.oneTimePasswordForm.controls.oneTimePassword.hasError('codeExpired')) {
      return 'talent-happy-path.quick-apply.otp-page.code-expired';
    } else {
        return 'talent-happy-path.quick-apply.otp-page.otp-invalid';
    }
  }

  async back() {
    const isFromInvite = this.activatedRoute.snapshot.queryParamMap.get('from') === 'invite';
    await this.workflowService.handleBackFromOtp(isFromInvite);
  }

  resendOneTimePasscode() {
    this.passcodeAttempts = 0;
    this.authServiceAPI.resendOneTimePasscode(this.talent.email).subscribe(
        data => {
          console.log("OTP resent")
        }, error => {
          console.error("Error resending OTP")
        }
    )
  }

  async navigateToPasswordPage(): Promise<void> {
    await this.workflowService.navigateToPasswordPage(this.activatedRoute);
  }
}
